import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
// import { fetchCouponByTableId, markCouponUsed } from "../api/firebase";
import store from "../store";
import { loadFromStorage } from "../utils";
import "./CompletePage.css";

/**
 * TODO: [x] 특정 쿠폰이 어느 사용자에게 발급됐는지 확인하는 로직 추가
 * TODO: [ ] 새로 고침 했을 때 발급된 쿠폰이 날라가지 않게 브라우저 저장소(세션 스토리지)에 저장 및 로딩 로직 구현
 */

const DEFAULT_COUPON_TEXT = "쿠폰이 모두 소진되었습니다";

function CompletePage() {
  const history = useHistory();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const formSubmitted = loadFromStorage("submitted") === "true";
  let timer: number;

  // useEffect(() => {
  //   fetchCoupon();
  // });

  // async function fetchCoupon() {
  //   try {
  //     const a = await fetchCouponByTableId();
  //     a.forEach(async (d) => {
  //       console.log(d.data());
  //       const coupon = d.data() as any;
  //       const docId = coupon.id;
  //       const r = await markCouponUsed(docId);
  //       console.log(r);
  //     });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  if (!formSubmitted) {
    history.replace("/");
    return <div></div>;
  }

  async function copyToClipboard() {
    if (!navigator.clipboard || !store.getCouponCode()) {
      return;
    }
    window.clearTimeout(timer);
    try {
      await navigator.clipboard.writeText(store.getCouponCode());
      setTooltipOpen(true);
      timer = window.setTimeout(() => {
        setTooltipOpen(false);
      }, 500);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="main">
      <header className="flex-column flex-all-center header px-8">
        <Link to="/">
          <img className="bi" src="./bi.png" alt="캡틴판교 x 인프런" />
        </Link>
      </header>
      <main className="px-2 notice font-medium">
        <div className="pb-8">
          <h2 className="pb-4">
            할인 쿠폰이 발급되었습니다.
            <br />
            힘이 되는 수강평 한마디도 부탁드려요! 😄
          </h2>
          <h4 className="py-1 text-medium">쿠폰 번호</h4>
          {/* TODO: 신청한 강좌 쿠폰이 아래에 삽입될 수 있도록 조정 */}
          <p className="pt-1 pb-2 font-normal">
            {store.getCouponCode() || DEFAULT_COUPON_TEXT}
          </p>
          {/* TODO: 복사하기 버튼 누르면 클립 보드에 복사하는 기능 구현 */}
          {/* TODO: 복사하기 버튼 누르면 '복사되었습니다' 툴팁 애니메이션으로 표시되도록 구현 */}
          <div className="button-wrapper">
            <button
              className="btn rounded px-4 py-2 text-small"
              type="button"
              onClick={() => copyToClipboard()}
            >
              복사하기
            </button>
            <span
              className={`tooltip py-1 px-2 ${tooltipOpen ? "open" : null}`}
            >
              복사 되었습니다
            </span>
          </div>
        </div>
        <div className="pb-8">
          <p className="pb-2 text-small">
            아래 링크로 50% 할인 쿠폰을 바로 적용해보세요!
          </p>
          <a
            className="link rounded px-4 py-2 text-small"
            href={store.getCourseLink()}
            target="_blank"
            rel="noreferrer"
          >
            쿠폰 바로 적용하기
          </a>
        </div>
        <div className="pb-8">
          <p className="pb-2 text-small">
            FE 개발자를 준비하는 학생/취준생을 위한
            <br />
            조언과 실무 이야기
          </p>
          <a
            className="link rounded px-4 py-2 text-small"
            href="https://www.youtube.com/@captainpangyo/featured"
            target="_blank"
            rel="noreferrer"
          >
            캡틴판교의 라이브 방송 보러가기
          </a>
        </div>
        <div className="pb-8">
          <p className="pb-2 text-small">
            <strong>Next.js 시작하기</strong> 강의가 나왔어요 🎁
          </p>
          <a
            className="link rounded px-4 py-2 text-small"
            href="https://inf.run/eTqGZ"
            target="_blank"
            rel="noreferrer"
          >
            강의 보러 가기
          </a>
        </div>
        <div className="pb-8">
          <p className="pb-2 text-small">
            <strong>국내 1위</strong> 타입스크립트 도서 <br />
            캡틴판교의 {`"쉽게 시작하는 타입스크립트"`}
          </p>
          <a
            className="link rounded px-4 py-2 text-small"
            href="https://www.yes24.com/Product/Goods/119410497"
            target="_blank"
            rel="noreferrer"
          >
            책 보러 가기
          </a>
        </div>
        {/* <div className="pb-8">
          <p className="pb-2 text-small">
            사이트 개선 사항이나 버그 제보 환영합니다 😄
          </p>
          <a
            className="link rounded px-4 py-2 text-small"
            href="mailto:jangkeehyo@gmail.com?subject=[캡팡] 학생 할인 사이트 관련 의견"
          >
            캡틴에게 의견주기
          </a>
        </div> */}
      </main>
      <footer className="px-2 py-4 notice">
        <p className="text-small font-medium font-gray">캡틴판교 x 인프런©</p>
      </footer>
    </div>
  );
}

export default CompletePage;
